import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  matInfo,
  matIosShare,
  matMoreVert,
} from '@ng-icons/material-icons/baseline';
import { matAddBoxOutline } from '@ng-icons/material-icons/outline';
import { TranslateModule } from '@ngx-translate/core';

import { GuideStep } from './add-home-screen-guide-dialog.interface';

@Component({
  selector: 'app-add-home-screen-guide-dialog',
  templateUrl: './add-home-screen-guide-dialog.component.html',
  imports: [NgIcon, TranslateModule],
  viewProviders: [
    provideIcons({
      matAddBoxOutline,
      matInfo,
      matIosShare,
      matMoreVert,
    }),
  ],
})
export class AddHomeScreenGuideDialogComponent {
  readonly activeModal = inject(NgbActiveModal);

  readonly steps: GuideStep[] = [
    {
      number: 1,
      titleKey: 'AddHomeScreenGuide.Step1Title',
      descriptionKey: 'AddHomeScreenGuide.Step1Description',
      tiles: [
        { icon: 'matIosShare', labelKey: 'UI.Interaction.Share' },
        { icon: 'matMoreVert', labelKey: 'Menu' },
      ],
    },
    {
      number: 2,
      titleKey: 'AddHomeScreenGuide.Step2Title',
      descriptionKey: 'AddHomeScreenGuide.Step2Description',
      tiles: [
        { icon: 'matAddBoxOutline', labelKey: 'AddHomeScreenGuide.Title' },
      ],
    },
    {
      number: 3,
      titleKey: 'Confirm',
      descriptionKey: 'AddHomeScreenGuide.Step3Description',
      tiles: [],
    },
  ];

  close(): void {
    this.activeModal.close();
  }
}
